import { FC, CSSProperties } from "react";
import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

interface InfoBoxProps {
  label: string | number;
  value: string | number;
  style?: CSSProperties;
  horizontal?: boolean;
  bigLabel?: boolean;
}

export const InfoBox: FC<InfoBoxProps> = ({ label, value, style, horizontal, bigLabel }) => {
  const classes = useStyles();
  return horizontal ? (
    <Box className={classes.wrapper} style={style}>
      <Typography className={classes.labelHoriz}>{label}:</Typography>
      <Typography className={classes.valueHoriz}>{value || "No data"}</Typography>
    </Box>
  ) : (
    <Box style={style}>
      <Typography
        className={`${bigLabel ? classes.bigLabel : classes.smallLabel} ${classes.label}`}
      >
        {label}
      </Typography>
      <Typography className={classes.value}>{value || "No data"}</Typography>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: "flex",
    alignItems: "center",
    marginRight: 10,
  },
  bigLabel: {
    fontSize: 32,
  },
  smallLabel: {
    fontSize: 14,
  },
  label: {
    display: "block",
    paddingBottom: 4,
    fontWeight: 600,
  },
  value: {
    display: "block",
    fontSize: 16,
    fontWeight: 400,
  },
  labelHoriz: {
    marginRight: 10,
    fontWeight: 600,
  },
  valueHoriz: {},
}));
